import { render, staticRenderFns } from "./Guardia.vue?vue&type=template&id=35848d7d&"
import script from "./Guardia.vue?vue&type=script&lang=js&"
export * from "./Guardia.vue?vue&type=script&lang=js&"
import style0 from "./Guardia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports